import { render, staticRenderFns } from "./ChatModalClient.vue?vue&type=template&id=00b1500f&scoped=true"
import script from "./ChatModalClient.vue?vue&type=script&lang=js"
export * from "./ChatModalClient.vue?vue&type=script&lang=js"
import style0 from "./ChatModalClient.vue?vue&type=style&index=0&id=00b1500f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1500f",
  null
  
)

export default component.exports